<template>
  <div>
    <!-- 提出赔款 -->
    <el-dialog :title="$t('message.billOfIndemnity') + ':' + reparation_sn + `  状态：(待提出)`" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1500px" center>
      <!-- 赔款原因 -->
      <div class="reason-head">
        <div class="reason">
          <!-- 赔款金额 -->
          <div class="row">
            <div class="label">{{ $t('message.compensationAmount') }}(元):</div>
            <div class="text">
              <el-input v-model="porder_reparation_amount" :disabled="isEdit" @input="handleInputPrice"> </el-input>
            </div>
          </div>
          <!-- 赔款原因 -->
          <div class="row">
            <div class="label">{{ $t('message.reasonForCompensation') }}:</div>
            <div class="text">
              <el-input v-model="reason" type="textarea" :disabled="isEdit"></el-input>
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <div class="reason">

          <div class="row">
            <div class="label">{{ $t('message.pic') }}:</div>
            <div class="text">
              <el-upload :action="baseURL + '/api/common/uploadFile'" list-type="picture-card"
                :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :file-list="fileList"
                :on-success="successup" :limit="3" drag multiple :disabled="isEdit" :before-upload="befoUpload">
                <i class="el-icon-plus" v-if="!isEdit"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <!-- add 添加责任人 -->
        <div class="add">
          <el-button type="success" size="mini" @click="add" v-if="isAuth(346) && !isEdit">{{
            $t('message.addResponsiblePerson')
          }}</el-button>
        </div>
        <!-- 赔款人 -->
        <div class="indemnity_details">
          <!-- 主责任人 -->
          <div class="responsible_box">
            <div class="responsible_person">
              <!-- 赔款类别 -->
              <div class="row">
                <div class="label">
                  {{ $t('message.compensationCategory') }}:
                </div>
                <div class="val">
                  <el-select filterable v-model="reparation_reason" size="mini" placeholder="请选择">
                    <el-option v-for="item in reparationReasonList" :label="item" :value="item" :key="item">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- 赔款数量:： -->
              <div class="row">
                <div class="label">
                  {{ $t('message.amountOfIndemnity') }}:
                </div>
                <div class="val"><el-input v-model="reparation_num" size="mini" @blur="getReparationsByUser"
                    :disabled="isEdit"></el-input>
                </div>
              </div>
              <!-- 赔款类型:： -->
              <div class="row">
                <div class="label">
                  {{ $t('message.reparationType') }}:
                </div>
                <div class="val">
                  <el-select filterable v-model="reparation_type" size="mini" @change="getReparationsByUser"
                    placeholder="请选择" :disabled="isEdit">
                    <el-option v-for="item in reparationType" :label="item.value" :value="item.value" :key="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- 责任人类别： -->
              <div class="row">
                <div class="label">
                  {{ $t('message.categoryOfResponsiblePerson') }}:
                </div>
                <div class="val">
                  <!-- 公司员工 -->
                  <div class="item">
                    <div class=" radio">
                      <el-radio v-model="liable_type" label="1" @change="changeRadio" :disabled="isEdit">
                        {{ $t('message.companyEmployee') }}
                      </el-radio>
                    </div>
                    <div class="input">
                      <el-select v-model="liable_content" placeholder="请选择" size="small" @change="changeAdmin"
                        filterable :disabled="isEdit">
                        <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <!-- 外部物流公司 -->
                  <div class="item">
                    <div class=" radio">
                      <el-radio v-model="liable_type" label="2" @change="changeRadio" :disabled="isEdit">
                        {{ $t('message.externalLogisticsCompany') }}
                      </el-radio>
                    </div>
                    <div class="input">
                      <el-select filterable v-model="wuliuName"
                        :placeholder="$t('message.pleaseEnterTheLogisticsNumber')" size="mini"
                        @change="otherResponsibility" :disabled="isEdit">
                        <el-option v-for="item in logisticsList" :label="item.name" :value="item.name" :key="item.id">
                        </el-option>
                      </el-select>
                      <!-- <el-input v-model="wuliuName" size="small" @input="otherResponsibility"></el-input> -->
                    </div>
                  </div>
                  <!-- 第三方卖家 -->
                  <div class="item">
                    <div class=" radio">
                      <el-radio v-model="liable_type" label="3" @change="changeRadio" :disabled="isEdit">
                        {{ $t('message.thirdPartySeller') }}
                      </el-radio>
                    </div>
                    <div class="input">
                      <el-input v-model="thirdParty" size="small" @input="otherResponsibility"
                        :disabled="isEdit"></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 承担费用明细 -->
          <div class="expenses_details">
            <div class="total">
              <div class="item"> 理应赔款金额：<el-input v-model="should_amount"
                  @input="shouldAmountEdited = true"></el-input> 元</div>
              <div class="item">
                实际赔款金额：<el-input v-model="actual_amount"></el-input>元
              </div>
              <div class="item">团队赔款：<el-input v-model="team_amount" type="number" min="0"
                  step="0.01" @input="teamAmountEdited = true"></el-input>元</div>
            </div>
            <div class="table">
              <ol>
                <!-- 承担费用明细 -->
                <li>{{ $t('message.detailsOfExpensesBorne') }}</li>
                <!-- 责任人选择 -->
                <li>{{ $t('message.responsiblePersonSelection') }}</li>
                <!-- 责任人角色 -->
                <li>{{ $t('message.responsiblePersonRole') }}</li>
                <!-- 承担金额（元） -->
                <li>{{ $t('message.bearingRatio') }}（元）</li>
                <!-- 操作 -->
                <li class="flex05">{{ $t('message.operation') }}</li>
              </ol>
              <!-- 关联责任人 -->
              <ul v-for="(item, index) in reparationList" :key="index">
                <!-- 承担费用明细 -->
                <li>
                  <span v-if="item.type == 2"> {{ $t('message.associatedResponsiblePerson') }} {{ index }}</span>
                  <span v-else> 主责任人</span>
                </li>
                <!-- 责任承担人 -->
                <li>
                  <span v-if="item.type == 3 || item.main == '公司'">
                    {{ item.main }}
                  </span>
                  <el-select v-model="item.main" placeholder="请选择" size="small" @change="changeName($event, index)"
                    filterable v-else :disabled="isEdit">
                    <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
                    </el-option>
                  </el-select>
                </li>
                <!-- 责任人角色 -->
                <li>{{ item.name }}</li>
                <!-- 承担金额（元） -->
                <li> <input type="text" v-model="item.amount" onfocus="this.select()" :disabled="isEdit"
                    @input="actual_amount_total"></li>
                <!-- 操作 -->
                <li class="flex05">
                  <el-button type="danger" class="dark" size="mini" @click="del(index)"
                    v-if="!isEdit && item.type == 2">
                    {{ $t('message.delete') }}
                  </el-button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}</el-button>
        <!-- 赔款单-添加 -->
        <el-button type="primary" @click="storeReparation" v-if="isAuth(346)">
          {{ $t("message.billOfIndemnityAdded") }}
        </el-button>
      </span>

    </el-dialog>
    <!-- 查看大图 -->
    <el-dialog :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import { reparationType } from '@/utlis/options'
export default {

  data() {
    return {
      reparationType,
      dialogVisible: false,
      detail: {}, //详情
      liable_type: '', //责任人类别
      liable_content: '',//责任主体内容
      liable_name: '', //责任人名称
      wuliuName: '', //物流填写
      thirdParty: '',//第三方卖家
      reparation_num: 0, //赔款数量
      reparation_type: '默认', // 赔款类型
      reparation_reason: '',
      reparationList: [], //关联责任人
      responsiblePersonData: {
        type: '1',
        main: '',
        rate: 0,
        amount: 0,
        name: '',
        should_amount: 0,
      },
      total: 0,//合计
      reason: '',
      adminList: [],
      fileList: [],
      imgDialogVisible: false,
      dialogImageUrl: '',
      porder_reparation_amount: '',//配送单赔款总赔款金额
      porder_sn: '', //配送单
      porderData: {},
      reparationReasonList: [],//赔款类别选项
      reparation_reason: '',//赔款类别
      reparation_sn: '',
      spot_detail: {},
      should_amount: 0,//赔款单总理应赔款
      shouldAmountEdited: false,//人工修改后保留填写的理应赔款
      actual_amount: 0,//赔款单总实际赔款
      team_amount: 0,//团队赔款
      teamAmountEdited: false,//人工修改后不再跟随理应赔款
    };
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
    }),
    // 是否禁止编辑
    isEdit() {
      return false
    }
  },
  created() {
    // 获取赔款人
    this.$api.roleApi.accountNumberList({ pageSize: 99999, forSelect: 1 }).then(res => {
      this.adminList = res.data.data
    })
  },
  methods: {
    // 获取赔款类型选项
    reparationReason(liable_content) {
      this.reparation_reason = ''
      this.$api.capitalApi
        .reparationReason({ liable_content }).then(res => {
          this.reparationReasonList = res.data
          this.$forceUpdate()
        })
    },
    // 根据理应赔款计算金额
    getReparationsByUser() {
      let datas = {
        userName: this.responsiblePersonData.main_admin,
        shouleMoney: this.porder_reparation_amount,
        type: this.reparation_type,
        numbers: this.reparation_num
      }
      if ((datas.userName == '' || datas.type == '' || datas.numbers === '') || this.liable_type != 1) {
        return false
      }
      this.reparationList = []
      this.$api.capitalApi.getReparationsByUser(datas).then((res) => {
        if (res.errcode == 1) return false
        res.data.peikuan.forEach(item => {
          let nameData = this.adminList.find(items => items.realname == item.name)
          if (item.name == '公司') {
            this.reparationList.push({
              main: item.name,
              rate: 1,
              amount: item.amount,
              type: '2',
              name: item.name,
              should_amount: 0,
            })
          } else {
            this.reparationList.push({
              main: nameData.id,
              rate: 1,
              amount: item.amount,
              type: nameData.realname == datas.userName ? '1' : '2',
              name: nameData.role[0].name,
              should_amount: nameData.realname == datas.userName ? this.porder_reparation_amount : 0,
            })
          }
        })
        this.actual_amount_total()

      })
    },
    // 售后-赔款单-添加
    storeReparation() {
      let datas = {
        reparation_sn: this.reparation_sn,
        liable_type: this.liable_type,
        liable_content: '',
        reason: this.reason,
        in_sale_id: [],
        reparationList: JSON.parse(JSON.stringify(this.reparationList)),
        reparation_num: this.reparation_num,
        reparation_type: this.reparation_type,
        reparation_reason: this.reparation_reason,
        porder_reparation_amount: this.porder_reparation_amount,
        images: [],
        spot_detail_id: this.spot_detail.spot_detail_id,
        should_amount: this.should_amount,
        actual_amount: this.actual_amount,
        team_amount: this.team_amount,
      }
      // 关联赔款单
      let addReparationData = {
        spot_detail_id: this.spot_detail.spot_detail_id,
        reparation_sn: this.reparation_sn,
      };

      // 图片添加
      this.fileList.forEach(item => {
        if (item.response) {
          datas.images.push(item.response.data)
        } else {
          datas.images.push(item.url)
        }

      })
      // 责任主体内容(责任人ID,物流号,卖家ID)
      if (this.liable_type == 1) {
        datas.liable_content = this.liable_content
      } else if (this.liable_type == 2) {
        datas.liable_content = this.wuliuName
      } else if (this.liable_type == 3) {
        datas.liable_content = this.thirdParty
      }
      //  if (datas.reparation_reason == '') return this.$message.error('赔款类别未选择')
      if (this.porder_reparation_amount == '') return this.$message.error('请输入赔款金额')
      if (this.reason.trim() == '') return this.$message.error('请输入赔款原因')
      this.$api.capitalApi.storeReparation(datas).then(res => {
        this.$api.spotCheckApi.addReparation(addReparationData).then((res) => {
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.$parent.spotList()
        });
      })
    },
    //新增
    add() {
      this.reparationList.push({
        main: '',
        rate: 1,
        amount: 0,
        type: '2',
        name: '',
        should_amount: 0,
      })
    },
    // 删除
    del(i) {
      this.reparationList.splice(i, 1)
    },
    //责任人类别:选择
    changeRadio(e) {
      if (e == 1) {
        this.getReparationsByUser()
      } else if (e == 2) {
        this.reparationList = []
        this.reparationList.push({
          main: this.wuliuName,
          rate: 1,
          amount: this.porder_reparation_amount,
          type: '3',
          name: this.wuliuName,
          should_amount: this.porder_reparation_amount,
        })
      } else if (e == 3) {
        this.reparationList = []
        this.reparationList.push({
          main: this.thirdParty,
          rate: 1,
          amount: this.porder_reparation_amount,
          type: '3',
          name: this.thirdParty,
          should_amount: this.porder_reparation_amount,
        })
      } this.$forceUpdate()

    },
    //选择主责任人
    changeAdmin(e) {
      let item = this.adminList.find(item => item.id == e)
      if (item.role == false) return this.$message('未找到角色')
      this.responsiblePersonData.roleName = item.role[0].name
      this.liable_name = item.realname
      if (this.liable_type == 1) {
        this.responsiblePersonData.main = e
        this.responsiblePersonData.main_admin = this.liable_name
        this.getReparationsByUser()
        this.reparationReason(e)
      }
    },
    // 选择其他责任类别
    otherResponsibility() {
      if (this.liable_type == 2) {
        this.reparationList[0].name = this.wuliuName
        this.reparationList[0].main = this.wuliuName
      } else if (this.liable_type == 3) {
        this.reparationList[0].name = this.thirdParty ? this.thirdParty : '第三方买家'
        this.reparationList[0].main = this.thirdParty ? this.thirdParty : '第三方买家'

      }
    },
    // 关联责任人选择
    changeName(e, i) {
      let role = this.adminList.find(item => item.id == e).role
      if (role != false) {
        this.reparationList[i].name = role[0].name
      } else {
        this.reparationList[i].name = ''
      }
    },
    //新增 赔款单数据 重置数据
    addIndemnity(data) {
      this.spot_detail = data
      this.liable_type = '' //责任人类别
      this.liable_content = ''//责任主体内容
      this.liable_name = '' //责任人名称
      this.fileList = []
      this.wuliuName = '' //物流填写
      this.thirdParty = ''//第三方卖家
      this.reason = ''// 赔款原因
      this.porder_sn = '' //配送单
      this.porder_reparation_amount = 0 //理应赔款
      this.reparation_num = 0 //赔款数量
      this.reparation_type = '默认' // 赔款类型
      this.reparation_reason = ''
      this.reparationList = [] //关联责任人
      this.should_amount = 0
      this.shouldAmountEdited = false
      this.actual_amount = 0
      this.team_amount = 0
      this.teamAmountEdited = false
      this.responsiblePersonData = {
        type: '1',
        main: '',
        rate: 0,
        amount: 0,
        name: '',
      }
      this.reparation_sn = data.reparation_sn // 赔款单
      data.image.forEach(item => {  // 默认图片
        this.fileList.push({
          url: item
        })
      })
      this.total = 0 //合计
      this.dialogVisible = true
    },
    // 图片上传成功事件
    successup(res, file, fileList) {
      this.fileList = fileList
      this.$forceUpdate()
    },
    //上传前
    befoUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg", "image/svg+xml"].indexOf(file.type) != -1;
      if (!isJPG) {
        if (file.name.indexOf('HEIC') == -1) {
          this.$message.error("请上传图片");
          return isJPG;
        }
      }
      return isJPG;
    },
    // 删除图片
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    // 不能输入负数
    handleInputPrice() {
      this.porder_reparation_amount = ("" + this.porder_reparation_amount) // 第一步：转成字符串
        .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
        .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
        .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
        .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
      this.setShouldAmount()
    },
    setShouldAmount() {
      // 抽查赔款没有商品数量和单价，直接取业务填写的赔款总额。
      if (!this.shouldAmountEdited) {
        this.should_amount = Number(this.porder_reparation_amount || 0).toFixed(2)
      }
    },
    //实际赔款金额
    actual_amount_total() {
      this.actual_amount = 0
      this.team_amount = 0
      this.reparationList.forEach(item => {
        this.actual_amount += item.amount - 0
        this.team_amount += item.amount - 0
      })
    },
  },

};
</script>
<style lang='scss' scoped>
/deep/.el-radio__inner {
  transform: scale(1.5) !important;
}

/deep/.el-textarea__inner {
  height: 100px;
}

.head {
  padding: 0 24px;
  height: 56px;
  line-height: 56px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  margin-bottom: 16px;
  display: flex;
  position: relative;
  font-size: 14px;

  .item {
    margin-right: 60px;
  }

  .el-button {
    position: absolute;
    top: 8px;
    right: 24px;
  }
}

.reason-head {
  display: flex;

  .reason {
    flex: 1;


    &:nth-child(1) {
      margin-right: 100px;
    }

    .row {
      display: flex;
      margin-bottom: 24px;
      font-size: 16px;
      font-weight: 600;

      .label {
        width: 100px;
        line-height: 40px;

      }

      .text {
        flex: 1;
        margin-left: 20px;
      }
    }

  }
}


.imgList {
  margin-bottom: 30px;
}

.content {
  padding: 16px 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;



  .table_detail {
    .detail_head {
      display: flex;
      font-size: 14px;
      height: 60px;
      background: #545467;
      border-radius: 4px;
      color: #fff;
      margin-top: 20px;

      .order {
        display: flex;
        align-items: center;
        padding-left: 16px;
      }

      .item {
        margin-left: 60px;
        line-height: 60px;
      }
    }
  }



  .table {
    font-size: 12px;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      li {
        padding: 24px 0;
        position: relative;
      }
    }

    .flex15 {
      flex: 1.5;
    }

    .flex05 {
      flex: 0.5;
    }

    .attribute {
      width: 100%;
      text-align: center;
      max-height: 100px;
      overflow: hidden;

      .el-button {
        position: absolute;
        top: 5px;
        right: 10px;
      }
    }

    .imgList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .imgs {
        width: 40px;
        height: 40px;
        margin: 0px 0px 10px 10px;

        .el-image {
          width: 40px;
          height: 40px;
          border: 1px dashed #ccc;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          border-radius: 3px;
          cursor: pointer;
        }
      }
    }

    .radio {
      flex: 9;
      width: 100%;
      justify-content: flex-start;

      span {
        margin: 0 40px 0 13px;
      }
    }
  }

  .add {
    text-align: right;
    margin-top: 20px;
  }

  .indemnity_details {
    display: flex;
    margin-top: 24px;

    .responsible_box {
      .responsible_person {
        border: 2px solid #32323C;

        .row {
          border-bottom: 1px solid #32323C;



          &:nth-last-child(1) {
            border: 0
          }

          display: flex;

          .label {
            width: 150px;
            border-right: 1px solid #32323C;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 14px 0;
          }

          .val {
            flex: 1;
            padding: 14px 30px;

            .item {
              display: flex;
              line-height: 40px;

              .radio {
                width: 120px;
                margin-right: 10px;

              }

              .input {
                width: 180px;

                /deep/.el-select {
                  width: 100%;

                  .el-input__inner {
                    height: 32px;
                  }

                }

                /deep/.el-input {
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }


    .expenses_details {
      width: 1120px;
      margin-left: 50px;

      .total {
        display: flex;
        margin-bottom: 10px;

        .item {
          flex: 1;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          line-height: 40px;

          /deep/.el-input {
            width: 100px;
            margin: 0 10px;
          }
        }
      }

      input {
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        height: 38px;
        width: 70%;
        padding: 0 10px;
      }

      ul {
        li {
          &:nth-child(1) {
            background-color: #fff;
          }
        }
      }
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-textarea__inner {
    width: 90%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}

.operation {
  margin-top: 24px;
  text-align: right;
}

/deep/ .is-disabled {
  .el-input__inner,
  .el-textarea__inner,
  .el-radio__inner,
  .el-radio__label {
    background-color: #fff !important;
    color: #32323C !important;
  }
}

/deep/.el-upload-dragger {
  width: 118px;
  height: 118px;
  border: none;
}
</style>
